<head>
  <!-- Google Tag Manager -->

  <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

  <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
  <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
    style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->

<div class="templateCharts" *ngIf="username; else elseBlock">
  <div class="row" style="text-align: center; margin: auto;">
    <div class="col">
      <div class="card">
        <div class="card-body" style="margin: auto">
          <div class="row" style="align-items: center;">
            <div class="col">
              <h1 class="card-title">Welcome to your user profile {{username}}!</h1>
              <br />
              <h2 class="card-text">
                Please review your portfolio to date!
              </h2>
            </div>
            <div class="col">
              <div class="row">
                <div class="col">
                  <button (click)="logout()" class="btn btn--secondary">Log Out</button>
                </div>
              </div>
              <br/>
              <div class="row">
                <div class="col">
                  <button data-bs-toggle="modal" data-bs-target="#delete" class="btn btn--delete">Delete</button>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <br />



  <ul class="nav nav-pills mb-3 justify-content-center mobileTab" id="myTab" role="tablist" style="font-size: 2rem;">
    <!-- <li class="nav-item" role="presentation" class="navItems">
    <button class="nav-link active navText" id="feed-tab" data-bs-toggle="pill" data-bs-target="#feed" type="button" role="tab" aria-controls="feed" aria-selected="true"><i class="fa-solid fa-square-rss"></i> Feed</button>
  </li> -->
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link active navText" id="stats-tab" data-bs-toggle="pill" data-bs-target="#stats" type="button"
        role="tab" aria-controls="stats" aria-selected="false"><i class="fa-solid fa-chart-simple"></i> Stats</button>
    </li>
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link navText" id="feed-tab" data-bs-toggle="pill" data-bs-target="#feed" type="button"
        role="tab" aria-controls="feed" aria-selected="false" style="font-size: large"><i
          class="fa-solid fa-square-rss"></i> Feed</button>
    </li>
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link navText" id="port-tab" data-bs-toggle="pill" data-bs-target="#port" type="button"
        role="tab" aria-controls="port" aria-selected="false"><i class="fa-solid fa-chart-pie"></i> Portfolio</button>
    </li>
  </ul>
  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="stats" role="tabpanel" aria-labelledby="stats-tab">
      <section class="section" #screen id="theGraph" style="padding-top: 0rem; padding-bottom: 0rem;">
        <div class="shell shell--size-3">
          <br />
          <div class="row chart" style="font-size: large">
            <div class="col">
              <div class="row" style="margin-bottom: -16%; line-height: 0%;">
                <div class="chart__head">
                  <div class="chart__head-content" style="margin-bottom: 10%">
                    <!-- <h6>eToro Analysis</h6> -->

                    <h5 *ngIf="mainChartStats" style="color: #5ECE42">{{username}}</h5>
                    <h5 *ngIf="!mainChartStats" style="color: #5ECE42">Cosmic Algorithm Ltd.</h5>

                    <span style="font-size: x-small" *ngIf="mobile">LIVE: {{DynamUpd}}</span><br />
                    <span style="font-size: small" *ngIf="!mobile">LIVE: {{DynamUpd}}</span><br />
                    <!-- <span>Last Updated: {{updateRecent}}</span> -->
                  </div><!-- /.chart__head-content -->

                </div><!-- /.chart__head -->
              </div>
            </div>
            <div class="col" style="font-size: medium; text-align: center;" *ngIf="mobile && mainChartStats">
              <div class="row" style="text-align: center;">
                <span>Daily Gain:</span><br />
                <span *ngIf="dailyVal < 0" class="legendRed">{{dailyVal}}%</span><span *ngIf="dailyVal > 0"
                  class="legendGreen">+{{dailyVal}}%</span>
              </div>
            </div>


            <div class="col" style="font-size: medium; text-align: center;" *ngIf="mobile && mainChartStats">
              <span>Monthly:</span><br />
              <span *ngIf="monthlyVal < 0" class="legendRed">{{monthlyVal}}%</span><span *ngIf="monthlyVal > 0"
                class="legendGreen">+{{monthlyVal}}%</span>
            </div>
            <div class="col" style="font-size: medium; text-align: center;" *ngIf="!mobile">
              <table style="width:50%">
                <tr *ngIf="mainChartStats">
                  <td style="text-align: left;">Daily Gain:</td>
                  <td style="text-align: right;"><span *ngIf="dailyVal < 0" class="legendRed">{{dailyVal}}%</span><span
                      *ngIf="dailyVal > 0" class="legendGreen">+{{dailyVal}}%</span></td>
                </tr>
                <tr *ngIf="mainChartStats">
                  <td style="text-align: left;">Monthly Gain:</td>
                  <td style="text-align: right;"><span *ngIf="monthlyVal < 0"
                      class="legendRed">{{monthlyVal}}%</span><span *ngIf="monthlyVal > 0"
                      class="legendGreen">+{{monthlyVal}}%</span></td>
                </tr>
              </table>
            </div>

            <div *ngIf="!mobile" class="col-auto legendGrad legendShadow" id="legend"
              style="line-height: 90%; height:fit-content; padding-top: 0.5%; padding-bottom: 0.5%;">
              <div id="legendItems">
                <div class="row" style="display: flex">
                  <div class="col-auto">AGR +/- (Since Launch)</div>
                  <div class="col-auto" style="flex-grow: 1; text-align: right;">
                    <!-- <span id="tLaunch">
                      <span
                        *ngIf="lPos">+</span>{{perfLaunch}}%
                      </span> -->
                      <span *ngIf="!lPos && mainChartStats" class="legendRed">{{perfLaunch}}%</span>
                      <span *ngIf="lPos && mainChartStats" class="legendGreen">+{{perfLaunch}}%</span>
                      <span *ngIf="mainPerfPos && !mainChartStats" class="legendGreen">+{{mainPerf}}%</span>
                      <span *ngIf="!mainPerfPos && !mainChartStats" class="legendRed">{{mainPerf}}%</span>
                  </div>
                </div>
                <div class="row" style="display: flex">
                  <div class="col-auto">Gain +/- (Since Launch)</div>
                  <div class="col-auto" style="flex-grow: 1; text-align: right;">
                    <!-- <span id="tNSDQ">
                      <span *ngIf="nPos">+</span>{{last}}%
                    </span> -->
                    <span *ngIf="!nPos && mainChartStats" class="legendRed">{{last}}%</span>
                    <span *ngIf="nPos && mainChartStats" class="legendGreen">+{{last}}%</span>
                    <span *ngIf="mainLastPos && !mainChartStats" class="legendGreen">+{{mainLast}}%</span>
                    <span *ngIf="!mainLastPos && !mainChartStats" class="legendRed">{{mainLast}}%</span>
                  </div>
                </div>
              </div>
            </div>
            <span *ngIf="mobile && !mainChartStats" style="margin-top: 2.5vh"></span>
            <div *ngIf="mobile" class="row legendGrad legendShadow" id="legend"
              style="line-height: 100%; height:fit-content; padding-top: 0.5%; padding-bottom: 0.5%; margin-top: 2%">
              <div id="legendItems">
                <div class="row">
                  <div class="col">AGR +/- (Since Launch)</div>
                  <div class="col-auto legendPadMob">
                    <!-- <span id="tLaunch">
                      <span
                        *ngIf="lPos">+</span>{{perfLaunch}}%
                      </span> -->
                      <span *ngIf="!lPos && mainChartStats" class="legendRed">{{perfLaunch}}%</span>
                      <span *ngIf="lPos && mainChartStats" class="legendGreen">+{{perfLaunch}}%</span>
                      <span *ngIf="mainPerfPos && !mainChartStats" class="legendGreen">+{{mainPerf}}%</span>
                      <span *ngIf="!mainPerfPos && !mainChartStats" class="legendRed">{{mainPerf}}%</span>
                    </div>
                </div>
                <div class="row">
                  <div class="col">Gain +/- (Since Launch)</div>
                  <div class="col-auto legendPadMob">
                    <!-- <span id="tNSDQ">
                    <span *ngIf=nPos>+</span>{{last}}%</span> -->
                    <span *ngIf="!nPos && mainChartStats" class="legendRed">{{last}}%</span>
                    <span *ngIf="nPos && mainChartStats" class="legendGreen">+{{last}}%</span>
                    <span *ngIf="mainLastPos && !mainChartStats" class="legendGreen">+{{mainLast}}%</span>
                    <span *ngIf="!mainLastPos && !mainChartStats" class="legendRed">{{mainLast}}%</span>
                  </div>
                </div>
              </div>
            </div>


            <!-- <div *ngIf="!mobile" class="col legendGrad legendShadow" id="legend" style="padding-top:1.5rem;">
              <div id="legendItems">
                <div class="row" style="margin-bottom: 10px; display: none">
                  <div class="col">AGR - 2021 (Traded Gain)</div>
                  <div class="col"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                </div>
                <div class="row" style="margin-bottom: 10px;">
                  <div class="col">AGR - Since Launch</div>
                  <div class="col"><span id="tLaunch"><span *ngIf="lPos">+</span>{{tLaunch}}%</span></div>
                </div>
                <div class="row" style="margin-bottom: 10px;">
                  <div class="col">NSDQ100 Index</div>
                  <div class="col"><span id="tNSDQ"><span *ngIf="nPos">+</span>{{nsdqVal}}%</span></div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="mobile" class="row legendGrad legendShadow" id="legend">
            <div id="legendItems">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col">AGR - 2021 (Traded Gain)</div>
                <div class="col-auto" style="padding-right: 1rem;"><span id="tGain"><span
                      *ngIf="gPos">+</span>{{tGain}}%</span> </div>
              </div>
              <div class="row" style="margin-bottom: 10px;">
                <div class="col">AGR - Since Launch</div>
                <div class="col-auto" style="padding-right: 1rem;"><span id="tLaunch"><span
                      *ngIf="lPos">+</span>{{tLaunch}}%</span></div>
              </div>
              <div class="row" style="margin-bottom: 10px;">
                <div class="col">NSDQ100 Index</div>
                <div class="col-auto" style="padding-right: 1rem;"><span id="tNSDQ"><span
                      *ngIf="nPos">+</span>{{nsdqVal}}%</span></div>
              </div>
            </div>
          </div> -->
          </div>
          <br />
          <div class="form-check form-switch" style="font-size: x-large; text-align: center;">
            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
              (click)="changeMainStats()">
            <label class="form-check-label" for="flexSwitchCheckDefault" style="font-size: large">Toggle View</label>
          </div>
          <br />
          <div class="row chart">
            <div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart">
              <div id="container" style="text-align:center;" style="height: 60vh">

              </div><!-- /.chart__body -->
              <div id="containerMain" class="hide" style="text-align:center;" style="height: 60vh">
              </div>
            </div>
          </div>
          <div style="text-align: center; font-size:small" *ngIf="!mobile">Past performance is not an indication of future results.</div><br/><br/>
          <div style="text-align: center; margin-left: 2vw; font-size: small;" *ngIf="mobile">Past performance is not an indication of future results.</div><br/><br/>
        </div><!-- /.shell -->
      </section>
      <br />
      <app-main-graph></app-main-graph>
      <div class="row" style="margin: auto;" #risk id="risk">
        <div class="col avgMarg">
          <div style="text-align: center; margin: auto;">
            <div style="margin:auto;">
              <section class="section" style="padding-top: 0rem; padding-bottom: 0rem;" id="about">
                <div class="shell shell--size-3">
                  <!-- <div class="section__head" *ngIf="!mobile">
                    <h6>Algorithm</h6>

                    <h2>Risk Score</h2>
                    <h3>{{username}}</h3>
                  </div>/.section__head -->
                  <div class="section__head">
                    <h2 *ngIf="myStats">Risk Score - {{username}}</h2>
                    <h2 *ngIf="!myStats">Risk Score - cosmicetoro</h2>
                    <div class="form-check form-switch" style="font-size: x-large;">
                      <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                        (click)="changeStats()">
                      <label class="form-check-label" for="flexSwitchCheckDefault" style="font-size: large">Toggle
                        View</label>
                    </div>
                  </div><!-- /.section__head -->
                </div>
              </section>
              <div id="containerRisk" class="riskCon" style="text-align: center; margin: auto"></div>
              <p style="font-size: large" *ngIf="myStats">Average Risk Score: <b>{{riskText}} / 10</b> &nbsp;<a
                  [routerLink]="['/information/risk']" id="RiskInformation" class="wow fadeInRight"
                  data-wow-delay="0.5s"><i class="fa-solid fa-circle-info fa-1x howItWorksiRemainingMob"></i></a></p>

              <div id="containerRiskGlobal" class="riskCon hide" style="text-align: center; margin: auto"></div>
              <p style="font-size: large" *ngIf="!myStats">Average Risk Score: <b>{{riskTextGlobal}} / 10</b> &nbsp;<a
                  [routerLink]="['/information/risk']" id="RiskInformation" class="wow fadeInRight"
                  data-wow-delay="0.5s"><i class="fa-solid fa-circle-info fa-1x howItWorksiRemainingMob"></i></a></p>
            </div>
          </div>

        </div>
      </div>
      <br />
      <!-- <app-global-risk></app-global-risk> -->
      <br />
      <div *ngIf="!mobile" style="margin-bottom: 1%">

      </div>
    </div>
    <div class="tab-pane fade feedTab" id="feed" role="tabpanel" aria-labelledby="feed-tab">
      <div class="row" style="margin: auto">
        <div class="col">
          <div>
            <div style="text-align: center; width:auto">
              <div style="margin:auto;">
                <div class="elfsight-app-1bd35861-fde3-4be5-9dfd-a51de5105af6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
    <div class="tab-pane fade" id="port" role="tabpanel" aria-labelledby="port-tab">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body" style="text-align: center; margin: auto; font-size: large">
              <div class="card-title"><b>Live Portfolio</b></div>
              This is your live portfolio, and will update frequently. These are all of your positions related to your
              engagement with Backseat Trader.
              <span class="card-text" class="table table-striped">
                <div class="portfolioTab">
                  <thead>
                    <tr>
                      <th class="portHeading">Name</th>
                      <th class="portHeading">Investment %</th>
                      <th class="portHeading">Net Profit</th>
                      <th class="portHeading">Open Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let position of portfolioPositions">
                      <td class="portHeading portLeft" style="text-align: left;">{{position.positionId}}</td>
                      <td class="portHeading">{{position.investmentPct}}</td>
                      <td class="portHeading">{{position.netProfit}}</td>
                      <td class="portHeading">{{position.openRate}}</td>
                    </tr>
                  </tbody>
                </div>

              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
	<div class="modal" id="delete">
		<div class="modal-dialog modal-fullscreen" style="align-content: center; display: grid;">
			<div class="modal-content">

	
				<div class="modal-body" style="font-size: large; margin: 1% 1% 1% 1%" *ngIf="mobile">
          <div class="row mb-3 mt-3">
            <div class="col">
              If you would like to delete your account, please enter your email and password into the fields below and click submit.
            </div>
          </div>
          <div class="row mb-5">
            <div class="col">
              This action is irreverisble and your account will be deleted instantly.
            </div>
          </div>
          <div class="row">
            <div class="col">
              <form [formGroup]="loginform" role="form" class="needs-validation" novalidate>

                <div class="form-group mb-3 theSpace">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                    </div>
                    <input type="email" formControlName="email" class="form-control" placeholder="&nbsp;Email"
                      aria-describedby="inputGroupPrepend" style="height:5rem; font-size:medium" required>
                  </div>
                  <div class="invalid-feedback d-block" *ngIf="submitted && f.email.errors">
                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                    Email is required
                  </div>
                </div>
                <br />

                <div class="form-group theSpace">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-unlock"></i></span>
                    </div>
                    <input [type]="hide ? 'password' : 'text'" formControlName="password"
                      class="form-control form-control-user" placeholder="&nbsp;Password"
                      style="height:5rem; font-size:medium" required>
                    <div class="input-group-append">
                      <button type="button" class="btn-primary text-center" (click)="hide = !hide"
                        style="padding-left:2rem; padding-right:2rem">
                        <i *ngIf="!hide" class="fas fa-eye text-white"></i>
                        <i *ngIf="hide" class="fas fa-eye-slash text-white"></i>
                      </button>
                    </div>
                  </div>
                  <div class="invalid-feedback d-block" *ngIf="submitted && f.password.errors">
                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                    Password is required
                  </div>
                </div>

                <div *ngIf="invalid" class="alert alert-danger text-white" role="alert">
                  <i class="fas fa-exclamation-triangle"></i> &nbsp;
                  Invalid credentials.
                </div>

                <div *ngIf="loading" class="text-center">
                  <div class="spinner-grow text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <button [hidden]="loading" type="submit" class="btn btn-primary btn-lg btn-block my-4" style="border-radius: 10px"
                      (click)="deleteAccount()" id="login"><span *ngIf="!deleteAttmpt">Delete Account</span><span *ngIf="deleteAttmpt">Are you sure?</span></button>



              <span *ngIf="invalid">{{invalid}}</span>
              </form>
            </div>
          </div>
				</div>

        <div class="modal-body mt-4" style="font-size: large; max-width: 50%; margin: auto" *ngIf="!mobile">
          <div class="row mb-3 mt-4">
            <div class="col">
              If you would like to delete your account, please enter your email and password into the fields below and click submit.
            </div>
          </div>
          <div class="row mb-5">
            <div class="col">
              This action is irreverisble and your account will be deleted instantly.
            </div>
          </div>
          <div class="row">
            <div class="col">
              <form [formGroup]="loginform" role="form" class="needs-validation" novalidate>

                <div class="form-group mb-3 theSpace">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                    </div>
                    <input type="email" formControlName="email" class="form-control" placeholder="&nbsp;Email"
                      aria-describedby="inputGroupPrepend" style="height:5rem; font-size:medium" required>
                  </div>
                  <div class="invalid-feedback d-block" *ngIf="submitted && f.email.errors">
                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                    Email is required
                  </div>
                </div>
                <br />

                <div class="form-group theSpace">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-unlock"></i></span>
                    </div>
                    <input [type]="hide ? 'password' : 'text'" formControlName="password"
                      class="form-control form-control-user" placeholder="&nbsp;Password"
                      style="height:5rem; font-size:medium" required>
                    <div class="input-group-append">
                      <button type="button" class="btn-primary text-center" (click)="hide = !hide"
                        style="padding-left:2rem; padding-right:2rem">
                        <i *ngIf="!hide" class="fas fa-eye text-white"></i>
                        <i *ngIf="hide" class="fas fa-eye-slash text-white"></i>
                      </button>
                    </div>
                  </div>
                  <div class="invalid-feedback d-block" *ngIf="submitted && f.password.errors">
                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                    Password is required
                  </div>
                </div>

                <div *ngIf="invalid" class="alert alert-danger text-white" role="alert">
                  <i class="fas fa-exclamation-triangle"></i> &nbsp;
                  Invalid credentials.
                </div>

                <div *ngIf="loading" class="text-center">
                  <div class="spinner-grow text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <button [hidden]="loading" type="submit" class="btn btn-primary btn-lg btn-block my-4" style="border-radius: 10px"
                      (click)="deleteAccount()" id="login"><span *ngIf="!deleteAttmpt">Delete Account</span><span *ngIf="deleteAttmpt">Are you sure?</span></button>



              <span *ngIf="invalid">{{invalid}}</span>
              </form>
            </div>
          </div>
				</div>

				<!-- Modal footer -->
				<div class="modal-footer" style="    margin: auto;
				margin-bottom: 1%;
				margin-top: -1%;">
        <div class="row">
          <div class="col">
            <button type="button" class="btn btn-success" data-bs-dismiss="modal" (click)="close(delete)" style="background-color: #5ECE42;   border: 0.2rem solid #5ECE42;">Close</button>
          </div>
        </div>
				</div>

			</div>
		</div>
	</div>
</div>
<ng-template #elseBlock>
  <div class="err">
    <h1>Please login or register!</h1>
  </div>
</ng-template>